import { Component, Input } from '@angular/core';
import { IncomeTaxRecord } from '../income-tax-compliance-card/income-tax-compliance-card.component';
import { DARPANRecord } from '../darpan-compliance-card/darpan-compliance-card.component';

@Component({
  selector: 'app-organization-info-card',
  templateUrl: './organization-info-card.component.html',
  styleUrls: ['./organization-info-card.component.scss']
})
export class OrganizationInfoCardComponent {
  @Input() organizationName: string = '';
  @Input() pan: string = '';
  @Input() incomeTaxData: IncomeTaxRecord[] = [];
  @Input() darpanMatches: DARPANRecord[] = [];
  @Input() primaryLocation?: string;
  @Input() pinCode?: string;
  @Input() district?: string;
  @Input() csr1?: string;

  get firstRecord(): IncomeTaxRecord | null {
    return this.incomeTaxData.length > 0 ? this.incomeTaxData[0] : null;
  }

  get firstDarpanMatch(): DARPANRecord | null {
    return this.darpanMatches.length > 0 ? this.darpanMatches[0] : null;
  }

  get computedPrimaryLocation(): string {
    if (this.primaryLocation) {
      return this.primaryLocation;
    }

    const record = this.firstRecord;
    if (!record) {
      return 'Not Available';
    }

    // Handle both camelCase (from API) and snake_case (from interface)
    const parts = [
      (record as any).flatDoorBuilding,
      (record as any).nameOfPremisesBuildingVillage,
      (record as any).areaLocality,
      (record as any).townCityDistrict,
      (record as any).state || record.state,
      (record as any).pinCode || (record as any).pincode
    ].filter(Boolean);

    const location = parts.join(' ').trim();
    return location || 'Not Available';
  }

  get ngoType(): string {
    return (this.firstDarpanMatch as any)?.ngoType || 'Not Available';
  }

  get computedDistrict(): string {
    if (this.district) {
      return this.district;
    }
    const record = this.firstRecord;
    if (!record) {
      return 'Not Available';
    }
    // Handle both camelCase and snake_case
    return (record as any).townCityDistrict || 'Not Available';
  }

  get csr1Display(): string {
    return this.csr1 || 'Not Available';
  }
}

